import { render, staticRenderFns } from "./grammar_flags_base_items.vue?vue&type=template&id=10073292&scoped=true&"
import script from "./grammar_flags_base_items.vue?vue&type=script&lang=js&"
export * from "./grammar_flags_base_items.vue?vue&type=script&lang=js&"
import style0 from "./grammar_flags_base_items.vue?vue&type=style&index=0&id=10073292&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10073292",
  null
  
)

export default component.exports